import { Box, BoxProps } from '@mui/material';

export function Container({ children, ...boxProps }: BoxProps) {
  return (
    <Box p={3} borderRadius="4px" bgcolor="common.white" {...boxProps}>
      {children}
    </Box>
  );
}
